module.exports = __webpack_public_path__ + "img/cptgb-4.43c5d58a.png";